<template lang="pug">
  AreaTemplate(
    :title="title"
    :subTitle="subTitle"
    :message="message"
    url="https://imasugu-bengoshi.com/"
    image="img/logo_bengoshi.png"
    :comment="comment"
    button_label="イマスグ弁護士の<br>サービスサイトへ"
  )
</template>

<script lang="js">
import AreaTemplate from '@/components/step03/AreaTemplate.vue';

export default {
  components: {
    AreaTemplate,
  },

  props: {
    priceData: {
      type: Object,
      default: {},
    },
  },
  computed: {
    title() {
      // if (this.priceData.style === 1) {
      //   return '財産の相続について迷ったらご相談ください';
      // }
      // return '財産の相続について迷ったらご相談ください';
      return '';
    },
    subTitle() {
      // if (this.priceData.style === 1) {
      //   return '当サイトの遺産相続専門家が回答いたします。';
      // }
      // return '当サイトの遺産相続専門家が回答いたします。';
      return '';
    },
    message() {
      // if (this.priceData.style === 1) {
      //   return 'ご自身の財産について、何から手をつけたらいいか分からない等のお悩みがございましたら、お気軽に 下記のフォームリンクよりご相談ください。遺産相続の専門家が回答いたします。';
      // }
      // return '全ての条件でページの最後に表示財産の相続について迷ったらご相談ください/当サイトの遺産相続専門家が回答いたします。
      // 本人が急死して、何から手をつけたらいいのか分からない等のお悩みがございましたら、お気軽に 下記のフォームリンクよりご相談ください。遺産相続の専門家が回答いたします。';
      return '';
    },
    comment() {
      return '「イマスグ弁護士」は、今すぐにZOOMで弁護士に相談できる革新的なサービスです。マッチング料完全無料で、今すぐ対応可能な全国の弁護士がオンライン上にスタンバイしています。※別途、各弁護士により相談料は異なります。';
    },
  },
  mounted() {
    this.$emit('area_data', {
      title: this.title,
      subTitle: this.subTitle,
      message: this.message,
      comment: this.comment,
    });
  },
};
</script>